module.exports = __webpack_public_path__ + "static/media/square-full.c26fd8b2.svg";